var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseEmpty',[_c('section',[_c('Filters',{attrs:{"showFiltersForm":_vm.showFiltersForm,"optionsCategory":_vm.category.filter(ele => !ele.inactive),"showOptionsfilter":[
					'grouping',
					'month',
					'year',
					'type',
					'category'
				],"expandedAdvancedFilters":true},on:{"clickSearch":_vm.search,"clickClose":_vm.closeFilters}})],1)]),_c('Base',{staticStyle:{"margin-top":"0px"},attrs:{"addWidth":"30px"}},[_c('div',{staticClass:"filter",class:[_vm.showFiltersForm ? 'filter-active' : ''],attrs:{"title":"Alterar Filtros"},on:{"click":_vm.filterDropDownActive}},[_c('FilterIcon')],1),_c('div',{staticStyle:{"height":"100%","overflow-y":"auto"}},[_c('ChartMedia',{attrs:{"title":`Análise Comparativa`,"showXAxisLabel":true,"showZoom":true,"chartKey":2,"showLegend":true,"filters":_vm.filters}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }